import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'

// import { editProjectIntegrations } from '../../actions'
import Hubspot from './Integrations/Hubspot'

// import { Button, Input } from 'antd'

class ProjectSettingsIntegrations extends Component {
  render () {
    // const { project, loading, t } = this.props
    // console.log(project)

    return (
      <div>
        <Hubspot />
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading
})

const mapDispatchToParams = {
  // editProjectIntegrations
}

export default connect(mapStateToProps, mapDispatchToParams)(translate('translations')(ProjectSettingsIntegrations))



// WEBPACK FOOTER //
// ./src/components/ProjectSettings/ProjectSettingsIntegrations.js